module.exports = __webpack_public_path__ + "img/btn.b3e7d761.svg";